<div class="wrap">
    <span class="m-b block"
          sizeClass="S: h4, XLM: h3"
          *iCms="'title' of component"></span>
    <ng-container *ifSize="'XL'">
        @for (row of component.quick_links_row; track row) {
        <div>
            <ng-container *ngTemplateOutlet="quickLinks ; context:{$implicit: row}"></ng-container>
        </div>
        }
    </ng-container>
    <ng-container *ifSize="'SM'">
        @for (row of component.quick_links_row; track row) {
        <ng-container *ngTemplateOutlet="quickLinks; context:{$implicit: row}"></ng-container>
        }
    </ng-container>
</div>
<ng-template #quickLinks
             let-row>
    @for (link of row.links; track link) {
    <href class="quick-link p1 inline-block b-radius-max p-a-2 m-r m-b-5 m-b-4-s bg-col-5 no-wrap cursor-pointer"
          [link]="link.link_url">
        <span *iCms="'link_copy' of link"></span>
    </href>
    }
</ng-template>
